module.exports = __webpack_public_path__ + "static/media/matching-score-coin-70.29088112.png";